module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ovalButton"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aa8354f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/ovalLabel/OvalButton.vue
// module id = 1803
// module chunks = 0